/**
 * Compare functions (to be used in combination with Array.prototype.sort)
 *
 * Examples:
 *
 *  [1,3,2].sort(sortAsc())
 *    => [1,2,3]
 *
 *  [{a:1}, {a:3}, {a:2}].sort(sortDesc(x => x.a))
 *    => [{a:3}, {a:2}, {a:1}]
 *
 * Examples using arrays:
 *
 *  [{a:3, b:0}, {a:2,b:4}, {a:2, b:5}].sort(sortDescending(x => [x.a, x.b]))
 *    => [{a:3, b:0}, {a:2, b:5}, {a:2,b:4}]
 */

const internalSort = (keySelector = x => x, desc = true) => {
  const op = desc ? 1 : -1;

  return (a, b) => {
    a = keySelector(a);
    b = keySelector(b);

    if (!Array.isArray(a)) {
      return a === b ? 0 : a > b ? -op : op;
    } else {
      for (let i = 0; i < a.length; i++) {
        if (a[i] > b[i]) return -op;
        else if (b[i] > a[i]) return op;
      }
      return 0;
    }
  };
};

export const sortDesc = keySelector => internalSort(keySelector, true);
export const sortAsc = keySelector => internalSort(keySelector, false);
